const servicesUtils = require('utils/Services');
const shouldServiceRun = servicesUtils.shouldServiceRun;
const locationUtils = require('utils/Location');

module.exports = (function () {
    // Stop service from loading if not necessary
    if (!shouldServiceRun.catalog()) {
        return;
    }

    const Events = require('utils/framework/Events');
    Sephora.Util.InflatorComps.services.CatalogService = {
        catalogEngine: 'NLP',
        isNLPCatalog: () =>
            Sephora.configurationSettings?.isNLPSearchEnabled &&
            (locationUtils.isSearchPage() || Sephora.Util?.InflatorComps?.services?.CatalogService?.catalogEngine === 'NLP')
    };

    window.dispatchEvent(new CustomEvent(Events.CatalogEngineReady, { detail: {} }));
}());
